import xlsx from "json-as-xlsx";
import moment from 'moment';
const ArchivosExportar = (content) => {
 
   let columns = [
        { label: 'ID Archivo', value: 'id_aviso' },
        { label: 'Categoría', value: 'categoria' },
        { label: 'Título', value: 'titulo' },
        { label: 'Noticia', value: 'aviso' },
        { label: 'Fecha registro', value: 'created_at' }
      ];
      
      let settings = {
        sheetName: 'Noticias_Archivos',
        fileName: 'Noticias_Archivos_' + moment().format("YYYYMMDD_HHmmss"),
        extraLength: 3,
        writeOptions: {}
      }
      
      xlsx(columns, content, settings, true);
  };
  export default ArchivosExportar;
